module.exports = __webpack_public_path__ + "static/media/SanAntonio.7443c575.png";